/** Session / query keys for users arriving from the new LP (deep links). */

export const OFFSHORE_FLOW_SESSION_KEY = 'offshore2go_offshore_flow_intent';

/** Query: ?offshore_jurisdiction=bahamas|delaware|panama — only used with offshore_flow=open (objectives step). */
export const OFFSHORE_JURISDICTION_SESSION_KEY = 'offshore2go_offshore_jurisdiction_intent';

export const OFFSHORE_JURISDICTION_QUERY_PARAM = 'offshore_jurisdiction';

export type OffshoreJurisdictionSlug = 'bahamas' | 'delaware' | 'panama';

export const OFFSHORE_JURISDICTION_SLUGS: OffshoreJurisdictionSlug[] = ['bahamas', 'delaware', 'panama'];

export function isOffshoreJurisdictionSlug(value: string | null | undefined): value is OffshoreJurisdictionSlug {
  if (!value) return false;
  return OFFSHORE_JURISDICTION_SLUGS.includes(value.toLowerCase() as OffshoreJurisdictionSlug);
}

/** Match API `description` (e.g. "Panamá") to LP slug `panama`. */
export function jurisdictionDescriptionMatchesIntentSlug(description: string, slug: string): boolean {
  const s = slug.toLowerCase();
  const d = description
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (s === 'panama') return d === 'panama';
  if (s === 'bahamas') return d === 'bahamas';
  if (s === 'delaware') return d === 'delaware';
  return false;
}
